import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppShell from '../components/AppShell';
import ProfileTab from '../components/dash/ProfileTab';
import { useMe, useFlash } from '../lib/useMe';

export default function ProfilePage() {
  const [me, setMe] = useMe();
  const flash = useFlash();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  if (!me) return <AppShell title="My Profile"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell
      title="My Profile"
      subtitle={`Krysha ID: ${me.krysha_id} · ${me.profile_live ? 'Live on Krysha' : 'Private'}`}
      testid="profile-page"
    >
      <ProfileTab me={me} setMe={setMe} flash={flash} startEdit={params.get('edit') === '1'} goTab={(t) => navigate(t === 'preferences' ? '/match-preferences?edit=1' : `/${t}`)} />
    </AppShell>
  );
}
